import { AfterViewInit, Component, computed, HostListener, inject, input, OnDestroy } from '@angular/core';
import { IonImg, IonIcon } from "@ionic/angular/standalone";
import { DisplayMedia } from 'src/app/models/image';
import { FileService } from 'src/app/services/file.service';
import { PlatformService } from 'src/app/services/platform.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  standalone: true,
  imports: [IonIcon, IonImg,],
})
export class PdfViewerComponent implements AfterViewInit, OnDestroy {
  fileService = inject(FileService);
  toastService = inject(ToastService);
  platformService = inject(PlatformService);

  value = input.required<DisplayMedia>();
  fileSize = computed(() => {
    const originalFile = this.value().originalFile;
    if (!originalFile) return;
    const size = originalFile.size / (1024 * 1024);
    const rounded = Math.round(size * 10) / 10;
    return `${rounded}MB`;
  });

  ngAfterViewInit(): void {
    const value = this.value();
    if (!value) return;
    if (value.src) return; // all set
    const objectName = value.objectName;
    if (objectName) {
      value.src = this.fileService.getFullObjectUrl('pdf-custom-field', objectName);
    } else if (value.originalFile) {
      value.src = URL.createObjectURL(value.originalFile);
    } else {
      this.toastService.error("Error reading PDF file");
    }
  }

  ngOnDestroy(): void {
    const src = this.value().src;
    if (src) {
      URL.revokeObjectURL(src);
    }
  }

  @HostListener('click', ['$event']) openFile(event: Event) {
    const src = this.value().src;
    if (!src) return;
    const isApp = this.platformService.isApp();
    if (isApp) {
      this.fileService.openFileNative(src);
    } else {
      window.open(src, '_blank');
    }
  }
}
